import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'mat-autocomplete[clearStaleSelectionOnOpen]',
})
export class ClearStaleSelectionOnOpenDirective implements OnInit, OnDestroy {
  @Input('clearStaleSelectionOnOpen') controlValue: unknown;

  private openedSubscription?: Subscription;

  constructor(private autocomplete: MatAutocomplete) {}

  ngOnInit(): void {
    this.openedSubscription = this.autocomplete.opened.subscribe(() => {
      if (this.isEmptyValue(this.controlValue)) {
        this.autocomplete.options.forEach((option) => option.deselect());
      }
    });
  }

  ngOnDestroy(): void {
    this.openedSubscription?.unsubscribe();
  }

  private isEmptyValue(value: unknown): boolean {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === 'string') {
      return value.trim().length === 0;
    }

    return false;
  }
}
